import {Injectable} from '@angular/core';
import {AbstractAuthorityService} from './abstract-authority.service';
import {catchError} from 'rxjs';
import {AuthorityDto, CreateAuthorityDto, UpdateAuthorityDto} from "@shared/dto";

@Injectable({
  providedIn: 'root'
})
export class AuthorityService extends AbstractAuthorityService<AuthorityDto, CreateAuthorityDto, UpdateAuthorityDto> {
  readPermissions(id: number) {
    return this.http.get<AuthorityDto[]>(`${this.endpoint}/${id}/permissions`).pipe(catchError(error => this.handleHttpErrorResponse(error)));
  }
}

